import axios, { AxiosRequestConfig } from 'axios';
import environment from 'constants/environments';
import sweetAlertService from 'utils/sweetAlertService';
import storageService from './storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import _ from 'lodash';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { LogInInfo } from 'bff/models/login';
import { setLoadingVisible } from 'redux/actions/modal.action';
import store from 'redux/store';
import { logOut } from 'redux/actions/components/member.action';
import { RouterSettings } from 'constants/models/routerSettings';

/**
 * @description 全局設定 AJAX Request 攔截器 (interceptor)
 */
axios.interceptors.request.use(
  function (config: any) {
    // 關貿相關 API 路由
    const tradeUrls = ['/vehicle/check/policyperiod', '/vehicle/check/mbidbdis63i'];
    // 寵物險等待訊息 API 路由
    const petUrls = ['/pet/chip/ins/query', '/pet/chip/detail/query', '/pet/eval/fee'];
    // spinning start to show
    // 判斷 API 網址是否為 執行付款
    handleSetLoadingVisible(
      true,
      config && config.url
        ? config.url.indexOf('/payment/') !== -1
        : false,
      config && config.url
        ? _.some(tradeUrls, (url: string) => config.url.indexOf(url) !== -1)
        : false,
      config && config.url
        ? petUrls.some(url => config.url.indexOf(url) !== -1)
        : false
    );

    config.baseURL = environment.apiUrl;
    // config.headers.Authorization = 'AUTH_TOKEN';
    config = handleAttachToken(config);
    // console.log('request', config);
    return config;
  },
  function (error) {
    handleSetLoadingVisible(false);
    return Promise.reject(error);
  }
);

/**
 * @description 全局設定 AJAX Response 攔截器 (interceptor)
 */
axios.interceptors.response.use(
  function (response) {
    // spinning hide
    handleSetLoadingVisible(false);
    // console.log('response', response);

    if (response &&
      response.data &&
      response.data.MWHEADER &&
      response.data.MWHEADER.RETURNCODE &&
      response.data.MWHEADER.RETURNCODE === ReturnCode.CodeNoAuth) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '',
        html: '您已在別處登入'
      }).then(res => {
        handleLogOut();
        window.location.href = RouterSettings.Login;
      });

      return Promise.reject(response);
    }

    return response;
  },
  function (error) {
    // console.log('response error', error);
    handleSetLoadingVisible(false);

    if (error.response) {
      switch (error.response.status) {
        case 401:
        {
          const unauthorizedMsg = storageService.getItem(storageKeys.UnauthorizedMsg);
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: '',
            html: unauthorizedMsg || '未經授權，請重新登入。'
          }).then(res => {
            if (res.value) {
              handleLogOut();
              window.location.href = RouterSettings.Login;
            }
          });
          break;
        }
        default:
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            html: '系統發生錯誤，請稍後再試，如有疑問請洽客服。'
          });

          if (error.response.config && error.response.config.url && error.response.config.url.indexOf('/info/systime') !== -1) {
            return error.response;
          }

          break;
      }
    }
    return Promise.reject(error);
  }
);

/**
 * @description 如果有 token 於 Request header 中加入
*/
const handleAttachToken = (config: AxiosRequestConfig) => {
  const passUrl: string[] = ['/login', '/captcha', '/carsurvey', '/info/codes'];

  // 如果為不需加入的呼叫就跳過
  if (_.some(passUrl, (str: string) => config.url?.indexOf(str) !== -1)) return config;

  let accessToken = '';
  if (storageService.getItem(storageKeys.LoginInfo)) {
    const loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo)) as LogInInfo;
    accessToken = loginInfo.access_token;
  }

  // 有 token 就修改 header
  if (accessToken) {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`
      }
    };
  }

  return config;
};

/**
 * @description 進行登出
*/
const handleLogOut = () => {
  const { dispatch } = store;
  dispatch(logOut());
};

/**
 * @description 開啟、關閉 Loading
 * @param visible 是否開啟
 * @param dealing 是否為執行付款 API
 * @param policyperiod 是否為保發關貿保期 API
*/
const handleSetLoadingVisible = (visible: boolean, dealing?: boolean, policyperiod?: boolean, petLoading?: boolean) => {
  const { dispatch } = store;

  dispatch(setLoadingVisible(visible, dealing, policyperiod, petLoading));
};
